import { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { positionDropdown } from '../../../common/dropdown'
import useDidUpdateEffect from '../../../common/hooks/useDidUpdateEffect'
import { Element } from '../../../common/html/element'
import { debounce } from '../../../helpers/common'
import { DropdownItem } from '../../common/DropdownItem'
import { InputCompany } from '../../common/InputCompany'
import { InputSearchDropdown } from '../../common/InputSearchDropdown'
import { FILTER_BY } from '../../constant'
import {
  changeFilter,
  selectFilter,
  selectListCompSearch,
  selectLoading,
} from '../store/slice'
import { getSearchCompany } from '../store/thunk'

export const SearchCompany = () => {
  const dispatch = useDispatch()
  const searchCompanyAndPerson = useSelector(
    selectFilter('searchCompanyAndPerson'),
  )
  const dataSearchCompany = useSelector(selectListCompSearch)
  const isLoadingSearch = useSelector(selectLoading('searchCompany'))
  const locale = useSelector((state) => state.i18n.locale)

  const [inputValue, setInputValue] = useState('')

  const dataSearchFormat = dataSearchCompany.filter(
    (item) =>
      !searchCompanyAndPerson
        .map((item1) => item1.organizationId)
        .includes(item.organizationId),
  )

  const handleChangeText = useCallback(
    debounce((value) => {
      dispatch(
        getSearchCompany({
          term: value,
          page: 1,
          pageSize: 100,
          minimal: true,
        }),
      )
    }, 700),
    [],
  )

  const handleOnFocus = () => {
    if (!dataSearchCompany.length) {
      handleChangeText(inputValue)
    }
  }

  const handleChoose = (value) => {
    setInputValue('')
    dispatch(
      changeFilter({
        searchCompanyAndPerson: [
          ...searchCompanyAndPerson,
          {
            type: FILTER_BY.COMPANY,
            ...value,
          },
        ],
      }),
    )
  }

  const renderElement = () => {
    return (
      <InputCompany
        containerStyle={{
          flex: 1,
          width: '100%',
          height: '28px',
        }}
        placeHolder="connectMap.main.SEARCH_COMPANY"
        type="text"
        isSearch
        onChange={setInputValue}
        value={inputValue}
        handleOnFocus={handleOnFocus}
      />
    )
  }

  const renderDropdown = ({ hideDropdown }) => {
    if (searchCompanyAndPerson.length >= 10) {
      return (
        <Element
          style={{
            fontStyle: 'italic',
            padding: 12,
            color: 'rgb(224, 80, 91)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Translate value="connectMap.main.PLEASE_SELECT_VALIDATION" />
        </Element>
      )
    }
    return (
      <div style={{ zIndex: 13 }}>
        {dataSearchFormat?.map((item) => (
          <DropdownItem
            key={item?.organizationId}
            item={item}
            hideDropdown={hideDropdown}
            handleChoose={handleChoose}
          />
        ))}
      </div>
    )
  }

  const renderNodata = () => {
    return (
      <Element style={{ fontStyle: 'italic', padding: 12 }}>
        <Translate value="connectMap.main.NODATA_ADD_COMPANY" dangerousHTML />
      </Element>
    )
  }

  useDidUpdateEffect(() => {
    if (inputValue.length !== 1) {
      handleChangeText(inputValue, locale)
    }
  }, [inputValue, locale])

  return (
    <InputSearchDropdown
      style={{ width: '100%' }}
      renderElement={renderElement}
      renderDropdown={renderDropdown}
      dropdownItemHeight={50}
      maxDropdownItem={10}
      data={dataSearchFormat}
      dropdownPosition={positionDropdown.BOTTOM_CENTER}
      isLoading={isLoadingSearch}
      renderNodata={renderNodata}
      isValidateTwoKey
      textInput={inputValue}
    />
  )
}
